/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_StopInputs */

const en_follow_stop = /** @type {(inputs: Follow_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unfollow`)
};

/**
* | output |
* | --- |
* | "Unfollow" |
*
* @param {Follow_StopInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const follow_stop = /** @type {((inputs?: Follow_StopInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_StopInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_follow_stop(inputs)
});